import React, { useState } from 'react'
import { Alert, Button, Group, PasswordInput, Stack, TextInput, Anchor } from '@mantine/core'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useActions } from 'src/state'
import { Link } from 'react-router-dom'

const validationSchema = yup.object({
    email: yup.string().required('Email is required').email('Invalid email address'),
    password: yup.string().required('Password is required').min(8, 'Password must be at least 8 characters').matches(/[a-zA-Z]/, 'Password must contain at least one letter'),
})

const SignInForm: React.FC = () => {

    const signInAction = useActions().signInAction
    const [formError, setFormError] = useState<string | null>(null)

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        onSubmit: async (values, { setErrors }) => {
            setFormError(null)
            const res = await signInAction(values)
            if (!res.success) {
                if (res.errors.form) setFormError(res.errors.form)
                if (Object.keys(res.errors.fields).length) setErrors(res.errors.fields)
                return
            }
            window.location.assign('/')
        },
    })

    return (
        <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
            <Stack gap="md">

                {formError && (
                    <Alert color="red">{formError}</Alert>
                )}

                <TextInput
                    type="email"
                    label="Email"
                    placeholder="Enter your email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && formik.errors.email}
                    radius="md"
                />

                <PasswordInput
                    label="Password"
                    placeholder="Enter your password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.password && formik.errors.password}
                    radius="md"
                />

                <Group justify="center" mt="xs">
                    <Anchor component={Link} to="/forgot-password" size="xs" c="dimmed">
                        Forgot password?
                    </Anchor>
                </Group>

                <Button
                    type="submit"
                    fullWidth
                    loading={formik.isSubmitting}
                    disabled={!formik.isValid || formik.isSubmitting}
                    mt="sm"
                    radius="xl"
                    size="md"
                >
                    Login
                </Button>

            </Stack>
        </form>
    )
}

export default SignInForm
